import { Box, Typography } from "@material-ui/core";
import { Grid, styled } from "@mui/material";
import React from "react";

// Import Swiper styles
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

import { TurnoInIndiaData } from "../../../constants/turnoInIndia";
import TurnoInIndiaCard from "./card";

const CustomTurnoInIndia = styled(Box)(({ theme }) => ({
  ".turno-in-india": {
    marginTop: "100px",
    ".heading": {
      fontSize: "54px",
      lineHeight: "160%",
      fontWeight: "600",
      color: "#1D3D24",
      textAlign: "center",
      marginBottom: "24px",
    },
    ".turno-india-box": {
      justifyContent: "center",
      alignItems: "center",
      paddingLeft : "80px",
    },
  },
  ".swiper-turno-india": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    ".turno-in-india": {
      marginTop: "24px",
      ".heading": {
        fontSize: "20px",
      },
      ".turno-india-box": {
        display: "none",
      },
    },
    ".swiper-turno-india": {
      display: "block",
      ".swiper-wrapper": {
        alignItems: "center",
      },
      ".swiper-slide": {
        display: "flex",
        justifyContent: "center",
        ".turno-in-india-card": {
          transform: "scale(0.9)",
        },
      },
      ".swiper-slide.swiper-slide-active": {
        ".turno-in-india-card": {
          transform: "scale(1)",
        },
      },
    },
  },
}));

const TurnoInIndia = () => {
  return (
    <CustomTurnoInIndia>
      <Box className="turno-in-india">
        <Typography className="heading">{"TURNO IN INDIA"}</Typography>
        <Swiper
          slidesPerView={1.4}
          spaceBetween={0}
          centeredSlides={true}
          pagination={false}
          loop={true}
          modules={[Pagination]}
          className="swiper-turno-india"
        >
          {TurnoInIndiaData.map((data, index) => {
            return (
              <SwiperSlide key={index}>
                <TurnoInIndiaCard details={data} />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <Grid container
           className="turno-india-box"
           spacing={2}
           >
          {TurnoInIndiaData.map((data) => {
            return <Grid item xs={12} sm={6} md={4} lg ={4} key={data?.title}> 
            <TurnoInIndiaCard key={data?.title} details={data} />;
          </Grid>;
          })}
        </Grid>
      </Box>
    </CustomTurnoInIndia>
  );
};
export default TurnoInIndia;
